import { render } from "./CampaignTemplate.vue?vue&type=template&id=8e074a56"
import script from "./CampaignTemplate.vue?vue&type=script&lang=js"
export * from "./CampaignTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__